export default __webpack_public_path__ + "static/media/1.fe6d6527.jpeg";